import { PageHeader } from "@ant-design/pro-components";
import { Message } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message, Select } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./SendPlainSms.module.css";

const SendPlainSms = () => {
  const [form] = Form.useForm();
  const [lines, setLines] = useState([]);
  const [linesLoading, setLinesLoading] = useState(true);
  const [linesError, setLinesError] = useState("");

  const [result, setResult] = useState({
    message: "",
    type: "",
  });

  useEffect(() => {
    loadLines();
  }, []);

  const loadLines = () => {
    api.get("/smsline/list?isKavenegarLookup=false")
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setLines(data);
        const preferred = data.find((line) => line.isDefault) || data[0];
        form.setFieldsValue({ line: preferred?.id });
      })
      .catch(() => setLinesError("خطا در دریافت خطوط پیامک"))
      .finally(() => setLinesLoading(false));
  };

  const sendRequest = (formData) => {
    if (!lines.some((line) => line.id === formData.line)) return;

    setResult({ message: "", type: "" });
    api
      .post("/smsline/sendplain", formData)
      .then((res) => {
        if (res.data?.status === "Sent") {
          setResult({
            message: "ارسال پیامک با موفقیت انجام شد.",
            type: "success",
          });
        } else {
          setResult({
            message: "مشکلی در ارسال پیامک به سرویس دهنده پیش آمده است.",
            type: "error",
          });
        }
      })
      .catch((error) => {
        let messageText = error.response?.data?.error?.message || "خطا در ارسال پیامک";
        message.error(messageText);
        setResult({
          message: messageText,
          type: "error",
        });
      });
  };

  return (
    <div className={styles.CopyRoadmap}>
      <PageHeader title="ارسال پیامک" avatar={{ icon: <Message />, size: "large", style: { paddingTop: "8px" } }} />

      <Card className={styles.Form}>
        <Form form={form} name="validateOnly" layout="vertical" autoComplete="off" onFinish={sendRequest}>
          {!linesLoading && (linesError || !lines.length) && (
            <Alert type={linesError ? "error" : "warning"} message={linesError || "برای نقش شما هیچ خط پیامکی مجاز نشده است."} />
          )}
          {lines.length > 0 && (
            <Form.Item
              name="line"
              label="خط ارسالی"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="خط ارسالی"
                options={Object.values(lines).map((line) => {
                  return { label: line.number + " - " + line.provider_title, value: line.id };
                })}
              />
            </Form.Item>
          )}

          <Form.Item
            name="mobile"
            label="موبایل"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="message"
            label="متن پیام"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={linesLoading || !lines.length || Boolean(linesError)}
            >
              ارسال پیام
            </Button>
          </Form.Item>

          {result.message && <Alert message={result.message} type={result.type} />}
        </Form>
      </Card>
    </div>
  );
};

export default memo(SendPlainSms);
